var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-record-template" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "mt20",
          attrs: { data: _vm.list, size: "small" },
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号", width: "60" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "acea-row row-middle" }, [
                      _c("div", { staticClass: "line1" }, [
                        _vm._v(" " + _vm._s(scope.$index + 1) + " "),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作记录",
              "min-width": "400",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "acea-row row-middle" }, [
                      _c("div", { staticClass: "line1" }, [
                        _vm._v(
                          " " + _vm._s(scope.row.changeMessage || "-") + " "
                        ),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "订单状态", "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "acea-row row-middle" }, [
                      _c("div", { staticClass: "line1" }, [
                        _vm._v(" " + _vm._s(scope.row.orderStatusDesc) + " "),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作角色", "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "acea-row row-middle" }, [
                      _c("div", { staticClass: "line1" }, [
                        _vm._v(" " + _vm._s(scope.row.operatorRoleDesc) + " "),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作人",
              "min-width": "150",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "acea-row row-middle" }, [
                      _c("div", { staticClass: "line1" }, [
                        _vm._v(" " + _vm._s(scope.row.operatorName) + " "),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作时间", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "acea-row row-middle" }, [
                      _c("div", { staticClass: "line1" }, [
                        _vm._v(" " + _vm._s(scope.row.createTime) + " "),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }